import GoogleTagManagerController from 'components/analytics/google-tag-manager/google-tag-manager-controller';
import EventTrackerController from 'components/analytics/conversions/event-tracker-controller';
import TrackTriggerEventController from 'components/analytics/conversions/track-trigger-event-controller';
import TrackEventController from 'components/analytics/conversions/track-event-controller';
import TrackCompleteEventController from 'components/analytics/conversions/track-complete-event-controller';
import FormAnalyticsController from 'components/analytics/conversions/form-analytics-controller';
import ClickTrackController from 'controllers/click-track-controller';
import SearchAnalyticsController from 'components/analytics/search/search-analytics-controller';

window.EezyStimulusApplication.register('google-tag-manager', GoogleTagManagerController);

/* EventTrackerController is Deprecated */
window.EezyStimulusApplication.register('event-tracker', EventTrackerController);

/* Please use TrackTriggerEvent, TrackEvent, and TrackCompleteEvent controllers */
window.EezyStimulusApplication.register('track-trigger-event', TrackTriggerEventController);
window.EezyStimulusApplication.register('track-event', TrackEventController);
window.EezyStimulusApplication.register('track-complete-event', TrackCompleteEventController);

window.EezyStimulusApplication.register('form-analytics', FormAnalyticsController);
window.EezyStimulusApplication.register('click-track', ClickTrackController);
window.EezyStimulusApplication.register('search-analytics', SearchAnalyticsController);
